/* @flow */
import produce from 'immer'

export default function reducer(
  state,
  action: any
) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'CHANGE_TITLE':
        draft.title = action.value
        break
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        break
      case 'CHANGE_TITLE_ALIGNMENT': {
        draft.titleAlignment = action.value
        break
      }
      case 'CHANGE_PARAGRAPH_ALIGNMENT': {
        draft.paragraphAlignment = action.value
        break
      }
      case 'CHANGE_BUTTON_TEXT':
        draft.buttonText = action.value
        break
      case 'REMOVE_BACKGROUND_IMAGE':
        draft.backgroundImgUrl = ''
        draft.backgroundImgDimensions = {}
        break
      case 'CHANGE_BACKGROUND_IMAGE':
        const { url, dimensions } = action.value
        draft.backgroundImgUrl = url
        draft.backgroundImgDimensions = dimensions
        break
      case 'CHANGE_BG_OVERLAY_TRANSPARENCY':
        draft.bgOverlayTransparency = action.value
        break
      case 'CHANGE_PLACEHOLDER_TEXT':
        draft.placeholder = action.value
        break
      case 'SET_IMG_CROP_PARAMS':
        {
          const { imgCropParams } = action.value
          draft.imgCropParams = imgCropParams
        }
        break
      case 'REMOVE_IMAGE': {
        draft.imgUrl = ''
        draft.imgDimensions = {}
        draft.imgCropParams = {}
        break
      }
      case 'ADD_IMAGE': {
        draft.imgUrl = initialState.imgUrl
        draft.imgDimensions = initialState.imgDimensions
        break
      }
      case 'CHANGE_IMAGE': {
        const { url, dimensions } = action.value
        draft.imgUrl = url
        draft.imgDimensions = dimensions || {}
        draft.imgCropParams = {}
        break
      }
    }
  })
}
